import util from '../util'

let controller = 'cms/Operador'
export default Object.assign({}, util.GetCrud(controller, null), {
  ObterAcessos: function (dto, options) {
    if (options && options.data) dto.data = options.data
    return util.Axios.GetAll(controller + '/Acessos', dto)
  },
  Ativar: function (codigoOperador) {
    return util.Axios.Patch(controller + `/${codigoOperador}/AtivarAcesso`)
  }
})
